import {
	FunctionComponent,
	ReactNode,
	RefAttributes,
	forwardRef,
	useState,
} from 'react';
import { v4 as uuidv4 } from 'uuid';

import { HStack, Text } from '@montel/montelpro-shared-components-v2';
import { HiddenInput, StyledLabel } from './styles';
import CheckBoxIcon from './CheckboxIcon';
import { CheckboxState } from '../CheckboxTree.types';

export interface CheckboxProps {
	label?: ReactNode;
	state: CheckboxState;
	onChange?: (event: any) => void;
	[otherProps: string]: any;
}

export const Checkbox: FunctionComponent<CheckboxProps & RefAttributes<any>> =
	forwardRef<any, CheckboxProps>(
		({ label, state, onChange, ...otherProps }, ref) => {
			const [labelNodeId] = useState(uuidv4());

			return (
				<HStack>
					<StyledLabel id={labelNodeId}>
						<HiddenInput
							type="checkbox"
							onChange={onChange}
							ref={ref}
							{...otherProps}
						/>
						<CheckBoxIcon state={state} />
						<Text as="span" color={'textDefault'}>
							{label}
						</Text>
					</StyledLabel>
				</HStack>
			);
		},
	);

Checkbox.displayName = 'Checkbox';
